/* =========================================================================
   Healthy Manushya - Seed Match runtime. Vanilla port of the design's React
   interactions: reveals, drawn underlines, self-typing chat, EN/हिं toggle,
   pricing tabs, nav, sticky bar, AJAX cart + bottom-sheet checkout.
   DOM is built with createElement/textContent (no innerHTML) to avoid XSS.
   ========================================================================= */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var INR = function (cents) { return '₹' + Math.round(cents / 100).toLocaleString('en-IN'); };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var cartCount = 0;

  function mk(tag, css, text) {
    var e = document.createElement(tag);
    if (css) e.style.cssText = css;
    if (text != null) e.textContent = text;
    return e;
  }

  /* ---------- scroll reveal + drawn underlines ---------- */
  function revealEl(el) {
    el.classList.add('is-in');
    $$('[data-draw]', el).forEach(function (p) { p.style.strokeDashoffset = '0'; });
  }
  function initReveal() {
    var els = $$('.hm-seed [data-reveal]');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(revealEl); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { revealEl(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
    setTimeout(function () { els.forEach(function (e) { if (!e.classList.contains('is-in')) revealEl(e); }); }, 3000);
  }

  /* ---------- self-typing WhatsApp chat ---------- */
  function initChat() {
    var chats = $$('.hm-seed [data-chat]');
    if (!chats.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      chats.forEach(function (c) { $$('[data-bubble]', c).forEach(function (b) { b.style.opacity = '1'; b.style.transform = 'none'; }); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        $$('[data-bubble]', e.target).forEach(function (b, i) {
          setTimeout(function () { b.style.opacity = '1'; b.style.transform = 'none'; }, 170 * i + 140);
        });
        io.unobserve(e.target);
      });
    }, { threshold: 0.3 });
    chats.forEach(function (c) { io.observe(c); });
  }

  /* ---------- EN / हिं language ---------- */
  function applyLang(lang) {
    document.documentElement.setAttribute('data-hm-lang', lang);
    $$('[data-hm-hi]').forEach(function (el) {
      var hi = el.getAttribute('data-hm-hi');
      if (!hi) return;
      if (el.dataset.hmEn == null) el.dataset.hmEn = el.textContent;
      el.textContent = lang === 'hi' ? hi : el.dataset.hmEn;
    });
    $$('[data-hm-lang-set]').forEach(function (b) {
      var on = b.getAttribute('data-hm-lang-set') === lang;
      b.style.background = on ? '#15301C' : '#fff';
      b.style.color = on ? '#fff' : '#6B776A';
    });
  }
  function initLang() {
    var saved = 'en';
    try { var s = localStorage.getItem('hm_lang'); if (s === 'en' || s === 'hi') saved = s; } catch (e) {}
    applyLang(saved);
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-hm-lang-set]');
      if (!b) return;
      var lang = b.getAttribute('data-hm-lang-set');
      try { localStorage.setItem('hm_lang', lang); } catch (er) {}
      applyLang(lang);
    });
  }

  /* ---------- pricing plan tabs ---------- */
  function initTabs() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-hm-plan-set]');
      if (!b) return;
      var sec = b.closest('[data-hm-plan]');
      if (sec) sec.setAttribute('data-hm-plan', b.getAttribute('data-hm-plan-set'));
    });
  }

  /* ---------- nav: burger + scroll shadow ---------- */
  function initNav() {
    var toggle = $('[data-hm-navtoggle]'), menu = $('[data-hm-navmenu]'), nav = $('[data-hm-nav]');
    if (toggle && menu) {
      toggle.addEventListener('click', function () {
        var open = menu.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        // The drawer lives inside the sticky header, so on a 360x640 or iPhone SE its last
        // items fell below the fold with no way to reach them. Lock the page behind it and
        // let the drawer scroll itself (max-height lives in hm-seed.css).
        document.body.style.overflow = open ? 'hidden' : '';
      });
      function closeMenu() { menu.classList.remove('is-open'); toggle.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; }
      $$('a', menu).forEach(function (a) { a.addEventListener('click', closeMenu); });
      document.addEventListener('keyup', function (e) { if (e.key === 'Escape' && menu.classList.contains('is-open')) closeMenu(); });
    }
    if (nav) {
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () {
          var y = window.scrollY || window.pageYOffset;
          nav.style.boxShadow = y > 14 ? '0 10px 30px -22px rgba(21,48,28,.5)' : 'none';
          nav.style.background = y > 14 ? 'rgba(255,255,255,0.94)' : 'rgba(255,255,255,0.92)';
          ticking = false;
        });
      }, { passive: true });
    }
  }

  /* ---------- sticky bar (homepage) ---------- */
  function updateBar() {
    var bar = $('[data-hm-bar]'); if (!bar) return;
    var cartBtn = $('[data-hm-bar-cart]', bar), beginBtn = $('[data-hm-bar-begin]', bar);
    var isMobile = window.innerWidth < 820;
    var scrolled = (window.scrollY || window.pageYOffset) > window.innerHeight * 0.62;
    if (cartCount > 0) {
      if (cartBtn) cartBtn.style.display = 'flex';
      if (beginBtn) beginBtn.style.display = 'none';
      bar.classList.add('is-visible');
    } else {
      if (cartBtn) cartBtn.style.display = 'none';
      if (beginBtn) beginBtn.style.display = 'flex';
      bar.classList.toggle('is-visible', isMobile && scrolled);
    }
  }
  function initBar() {
    if (!$('[data-hm-bar]')) return;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () { updateBar(); ticking = false; });
    }, { passive: true });
    window.addEventListener('resize', updateBar);
  }

  /* ---------- Payment choice ----------
     Shopify checkout is the source of truth for payment availability. Keep the cart copy
     neutral so it never contradicts the checkout if a gateway or eligibility rule changes. */
  function applyCod(total, hasSub) {
    $$('[data-hm-cod-title]').forEach(function (e) { e.textContent = 'Cash on Delivery or pay online'; });
    $$('[data-hm-cod-tag]').forEach(function (e) { e.textContent = 'Choose at checkout'; e.style.color = '#2F6B2E'; });
    $$('[data-hm-cod-dot]').forEach(function (e) { e.style.background = '#2F6B2E'; });
    $$('[data-hm-cod-note]').forEach(function (e) { e.textContent = 'Pay when your order arrives, or use UPI, card or net banking. Free shipping and the 90-day Oath apply either way.'; });
    $$('[data-hm-place-label]').forEach(function (e) { e.textContent = 'Continue to checkout'; });
  }

  /* ---------- cart state + bubbles + bar ---------- */
  function setCartState(cart) {
    cartCount = cart.item_count;
    var hasSub = !!(cart.items && cart.items.some(function (it) { return it.selling_plan_allocation; }));
    applyCod(cart.total_price, hasSub);
    $$('[data-hm-bag-count]').forEach(function (b) {
      b.textContent = cartCount;
      b.style.display = cartCount > 0 ? 'inline-flex' : 'none';
    });
    var bt = $('[data-hm-bar-cart-total]'); if (bt) bt.textContent = INR(cart.total_price);
    var btop = $('[data-hm-bar-cart-top]');
    if (btop) btop.textContent = (cartCount === 1 ? '1 item' : cartCount + ' items') + ' · COD or online';
    updateBar();
  }
  function fetchCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }

  /* ---------- cart-notification toast (Dawn element, first-party section HTML) ---------- */
  function notify(state) {
    try {
      var cn = document.querySelector('cart-notification');
      var host = document.getElementById('cart-notification-product');
      if (!cn || !host || !state.sections || !state.sections['cart-notification-product']) return;
      var doc = new DOMParser().parseFromString(state.sections['cart-notification-product'], 'text/html');
      var node = doc.querySelector('[id="cart-notification-product-' + state.key + '"]') || doc.querySelector('.cart-item');
      while (host.firstChild) host.removeChild(host.firstChild);
      if (node) host.appendChild(document.importNode(node, true));
      if (typeof cn.open === 'function') cn.open();
      else { var n = document.getElementById('cart-notification'); if (n) n.classList.add('active'); }
    } catch (e) { /* toast is non-critical; bubble already updated */ }
  }

  /* ---------- bottom sheet ---------- */
  function lineRow(item) {
    var row = mk('div', 'display:flex;align-items:center;gap:12px;padding:14px 0;border-bottom:1px solid #EFEDE3');
    var img;
    if (item.image) { img = mk('img', 'width:46px;height:46px;border-radius:12px;object-fit:cover;flex:none'); img.src = item.image; img.alt = ''; img.width = 46; img.height = 46; }
    else { img = mk('div', 'width:46px;height:46px;border-radius:12px;background:linear-gradient(165deg,#EEF1E8,#E0E5D7);flex:none'); }
    row.appendChild(img);
    var mid = mk('div', 'flex:1;min-width:0');
    mid.appendChild(mk('div', 'font-size:15px;font-weight:500;letter-spacing:-0.01em;color:#15301C', item.product_title));
    mid.appendChild(mk('div', 'font-size:12.5px;color:#6B776A', INR(item.final_price) + ' each'));
    var alloc = item.selling_plan_allocation;
    if (alloc && alloc.selling_plan && alloc.selling_plan.name) {
      mid.appendChild(mk('div', 'margin-top:3px;font-size:11.5px;font-weight:600;color:#2F6B2E;letter-spacing:0.01em', '↻ ' + alloc.selling_plan.name));
    }
    row.appendChild(mid);
    var step = mk('div', 'display:flex;align-items:center;gap:4px;border:1px solid #E2E0D6;border-radius:100px;padding:3px');
    var dec = mk('button', 'width:30px;height:30px;border-radius:100px;border:none;background:#F2F1EA;color:#15301C;font-size:18px;cursor:pointer;font-family:inherit', '−');
    dec.type = 'button'; dec.setAttribute('data-hm-line-dec', ''); dec.setAttribute('data-key', item.key); dec.setAttribute('aria-label', 'Remove one');
    var qty = mk('span', 'min-width:18px;text-align:center;font-size:14px;font-weight:600;color:#15301C', String(item.quantity));
    var inc = mk('button', 'width:30px;height:30px;border-radius:100px;border:none;background:#2F6B2E;color:#fff;font-size:18px;cursor:pointer;font-family:inherit', '+');
    inc.type = 'button'; inc.setAttribute('data-hm-line-inc', ''); inc.setAttribute('data-key', item.key); inc.setAttribute('aria-label', 'Add one');
    step.appendChild(dec); step.appendChild(qty); step.appendChild(inc);
    row.appendChild(step);
    row.appendChild(mk('div', 'width:64px;text-align:right;font-size:14px;font-weight:500;color:#15301C', INR(item.final_line_price)));
    return row;
  }
  function renderSheet(cart) {
    var lines = $('[data-hm-lines]'), empty = $('[data-hm-empty]'), checkout = $('[data-hm-checkout-ui]');
    if (!lines) return;
    while (lines.firstChild) lines.removeChild(lines.firstChild);
    // Empty bag shows a real empty state with a shop CTA. The address / COD / totals /
    // place-order block is hidden, because offering checkout on nothing to buy is noise.
    var isEmpty = !cart.items.length;
    if (empty) empty.style.display = isEmpty ? 'block' : 'none';
    if (checkout) checkout.style.display = isEmpty ? 'none' : 'block';
    if (!isEmpty) cart.items.forEach(function (it) { lines.appendChild(lineRow(it)); });
    var st = $('[data-hm-subtotal]'); if (st) st.textContent = INR(cart.total_price);
    var tt = $('[data-hm-total]'); if (tt) tt.textContent = INR(cart.total_price);
    // SUBSCRIBE5 applies at checkout, so this bag amount is before the refill discount.
    var subNote = $('[data-hm-subnote]');
    var hasSub = cart.items.some(function (i) { var pl = i.properties && (i.properties.Plan || i.properties.plan); return pl && /subscribe|refill/i.test(pl); });
    if (tt && tt.previousElementSibling) tt.previousElementSibling.textContent = hasSub ? 'Before refill discount' : 'Total';
    if (subNote) {
      subNote.style.display = hasSub ? 'block' : 'none';
      if (hasSub) subNote.textContent = 'Your 5% refill saving applies at checkout. Please check the final amount there.';
    }
  }
  function openSheet() {
    var ov = $('[data-hm-overlay]'), sh = $('[data-hm-sheet]');
    if (!sh) return;
    fetchCart().then(function (cart) { setCartState(cart); renderSheet(cart); });
    if (ov) ov.classList.add('is-open');
    sh.classList.add('is-open');
    document.body.classList.add('hm-sheet-open');
    document.body.style.overflow = 'hidden';
    var saved = getAddr();
    if (saved && saved.raw && /\b\d{6}\b/.test(saved.raw)) { var inp = $('[data-hm-addr]'); if (inp && !inp.value) inp.value = saved.raw; setTimeout(function () { checkDelivery(saved.raw); }, 60); }
  }
  function closeSheet() {
    var ov = $('[data-hm-overlay]'), sh = $('[data-hm-sheet]');
    if (ov) ov.classList.remove('is-open');
    if (sh) sh.classList.remove('is-open');
    document.body.classList.remove('hm-sheet-open');
    document.body.style.overflow = '';
  }

  /* ---------- add / change / place ---------- */
  // ---------- A/B + analytics ----------
  var HM_AB_EP = 'https://hm-admin-dashboard.vercel.app/api/ab/v2';
  var HM_AB_X = 'home_v2_2026_09_14';
  function hmAbSessionId() {
    try {
      var key = 'hm_ab_v2_sid', id = sessionStorage.getItem(key);
      if (!id) {
        id = (window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID() : (Date.now().toString(36) + Math.random().toString(36).slice(2));
        sessionStorage.setItem(key, id);
      }
      return id;
    } catch (_) { return ''; }
  }
  function hmAbEligible() {
    try { return !window.HM_AB_FORCED && window.HM_AB_EXPERIMENT === HM_AB_X && sessionStorage.getItem('hm_ab_v2_eligible') === '1'; }
    catch (_) { return false; }
  }
  function hmAbCartAttributes() {
    if (!hmAbEligible() || (window.HM_AB !== 'a' && window.HM_AB !== 'b')) return {};
    return { _hm_ab_experiment: HM_AB_X, _hm_ab_variant: window.HM_AB, _hm_ab_session: hmAbSessionId() };
  }
  // One funnel milestone per eligible homepage session. text/plain avoids a CORS preflight.
  function hmAbSend(e) {
    try {
      if (!hmAbEligible() || (window.HM_AB !== 'a' && window.HM_AB !== 'b')) return;
      var once = 'hm_ab_v2_sent_' + e;
      if (sessionStorage.getItem(once) === '1') return;
      sessionStorage.setItem(once, '1');
      var payload = JSON.stringify({ x: HM_AB_X, v: window.HM_AB, e: e, sid: hmAbSessionId(), p: location.pathname });
      if (navigator.sendBeacon) navigator.sendBeacon(HM_AB_EP + '/event', payload);
      else fetch(HM_AB_EP + '/event', { method: 'POST', body: payload, keepalive: true });
    } catch (_) {}
  }
  // Rich event -> GA4 if present (clicks/scroll/etc.), always variant-tagged.
  function hmTrack(name, params) {
    try { if (window.gtag) window.gtag('event', name, Object.assign({ ab_variant: window.HM_AB || 'a' }, params || {})); } catch (_) {}
  }
  function hmAbConvert(type) {
    if (!hmAbEligible()) return;
    hmAbSend(type); hmTrack('ab_' + type, {});
  } // 'add' | 'checkout'
  function hmCaptureUtm() {
    try {
      var qs = new URLSearchParams(location.search), seen = {};
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'utm_adid', 'utm_adsetid'].forEach(function (k) { var v = qs.get(k); if (v) seen[k] = v.slice(0, 120); });
      if (qs.get('fbclid')) seen.fbclid = qs.get('fbclid').slice(0, 200);
      if (Object.keys(seen).length) {
        sessionStorage.setItem('hm_utm_last', JSON.stringify(seen));
        if (!localStorage.getItem('hm_utm_first')) localStorage.setItem('hm_utm_first', JSON.stringify(Object.assign({ at: new Date().toISOString().slice(0, 10) }, seen)));
      }
    } catch (e) {}
  }
  // Hash links must land on the visible variant's section. A-sections own the ids;
  // B-sections carry data-hm-anchor. Pick whichever is actually rendered.
  function initAnchorRouter() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="#"]');
      if (!a) return;
      var url = new URL(a.href, location.href);
      if (url.pathname !== location.pathname && !(url.pathname === '/' && location.pathname === '/')) return;
      var id = url.hash.slice(1); if (!id) return;
      var cands = document.querySelectorAll('[id="' + id + '"], [data-hm-anchor="' + id + '"]');
      var target = null;
      cands.forEach(function (el) { if (!target && el.offsetParent !== null) target = el; });
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); history.replaceState(null, '', url.hash); }
    }, true);
  }
  function initAB() {
    hmCaptureUtm();
    try {
      if (window.HM_AB_HOME && !window.HM_AB_FORCED && window.HM_AB_MODE === 'ab' && (window.HM_AB === 'a' || window.HM_AB === 'b')) {
        sessionStorage.setItem('hm_ab_v2_eligible', '1');
        hmAbSessionId();
      }
    } catch (_) {}
    if (hmAbEligible()) { hmAbSend('exposure'); hmTrack('ab_exposure', {}); }
    // refresh cached bandit weights for the NEXT new visitor's assignment
    try { if (window.HM_AB_HOME && !window.HM_AB_FORCED) fetch(HM_AB_EP + '/weights').then(function (r) { return r.json(); }).then(function (d) { if (d && d.experiment === HM_AB_X && d.weights) localStorage.setItem('hm_ab_v2_w', JSON.stringify(d.weights)); }).catch(function () {}); } catch (_) {}
    // scroll depth -> GA4
    var hit = {};
    var onScroll = function () {
      var h = document.documentElement, sc = (window.scrollY + window.innerHeight) / (h.scrollHeight || 1) * 100;
      [25, 50, 75, 100].forEach(function (m) { if (sc >= m && !hit[m]) { hit[m] = 1; hmTrack('scroll_depth', { percent: m }); } });
    };
    var t; window.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(onScroll, 350); }, { passive: true });
    // every click -> GA4 (label + variant)
    document.addEventListener('click', function (ev) {
      var el = ev.target.closest && ev.target.closest('a,button,[data-hm-add],[data-hm-add-multi]'); if (!el) return;
      var label = (el.getAttribute('aria-label') || el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 60);
      hmTrack('click', { label: label });
    }, true);
  }

  // per-product add-button copy (also set as custom.cta_label metafield for Liquid surfaces)
  var HM_CTA = { 'stress-relief': 'Add to my calm', 'all-day-active-multivitamin': 'Add to my energy', 'plant-power-omega': 'Add to my focus', 'radiant-glow-resveratrol': 'Add to my glow', 'the-full-set': 'Add my full ritual', '90-day-transformation': 'Start my transformation' };

  // little dopamine charm when something lands in the bag: sparkle burst + bag bounce + badge pop
  function hmCharm(btn) {
    try {
      var bag = document.querySelector('[data-hm-bag]');
      if (bag) { bag.classList.remove('hm-bag-bounce'); void bag.offsetWidth; bag.classList.add('hm-bag-bounce'); }
      var badge = document.querySelector('[data-hm-bag-count]');
      if (badge) { badge.classList.remove('hm-pop'); void badge.offsetWidth; badge.classList.add('hm-pop'); }
      if (btn && btn.classList) { btn.classList.remove('hm-added-flash'); void btn.offsetWidth; btn.classList.add('hm-added-flash'); }
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!btn || !btn.getBoundingClientRect) return;
      var r = btn.getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top + r.height / 2;
      var colors = ['#9DC58E', '#2F6B2E', '#C9E3BC'];
      for (var i = 0; i < 8; i++) {
        var s = document.createElement('span'); s.className = 'hm-charm-dot';
        var ang = (Math.PI * 2 * i) / 8 + (i * 0.6), dist = 24 + (i % 3) * 16;
        s.style.left = cx + 'px'; s.style.top = cy + 'px';
        s.style.setProperty('--dx', Math.round(Math.cos(ang) * dist) + 'px');
        s.style.setProperty('--dy', Math.round(Math.sin(ang) * dist - 16) + 'px');
        s.style.background = colors[i % 3];
        document.body.appendChild(s);
        (function (el) { setTimeout(function () { el.parentNode && el.parentNode.removeChild(el); }, 760); })(s);
      }
    } catch (e) {}
  }

  function addToCart(id, openAfter, btn, qty, sellingPlan, properties) {
    if (!id) return;
    if (btn) { btn.disabled = true; btn.classList.add('hmx-busy'); }
    var body = { id: Number(id), quantity: qty || 1, sections: 'cart-notification-product', sections_url: window.location.pathname };
    if (sellingPlan) { body.selling_plan = Number(sellingPlan); }
    if (properties) { body.properties = properties; }
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (state) {
      if (state && state.status && state.status !== 200) throw new Error(state.description || 'add failed');
      return fetchCart().then(function (cart) {
        setCartState(cart);
        hmCharm(btn); hmAbConvert('add');
        if (openAfter) { renderSheet(cart); openSheet(); }
        else if (document.querySelector('[data-hm-cart-page]')) { window.location.reload(); }
        else { notify(state); }
      });
    }).catch(function () {
      window.location = (window.routes && window.routes.cart_url) || '/cart';
    }).then(function () {
      if (btn) { btn.disabled = false; btn.classList.remove('hmx-busy'); }
    });
  }
  // Add several variants in one go (Protocols + Build-your-stack). One /cart/add.js items call.
  function addMultiToCart(ids, openAfter, btn) {
    ids = (ids || []).map(Number).filter(Boolean);
    if (!ids.length) return;
    if (btn) { btn.disabled = true; btn.classList.add('hmx-busy'); }
    var items = ids.map(function (id) { return { id: id, quantity: 1 }; });
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json(); }).then(function (state) {
        if (state && state.status && state.status !== 200) throw new Error(state.description || 'add failed');
        return fetchCart().then(function (cart) { setCartState(cart); hmCharm(btn); hmAbConvert('add'); if (openAfter) { renderSheet(cart); openSheet(); } else { notify(state); } });
      }).catch(function () { window.location = (window.routes && window.routes.cart_url) || '/cart'; })
      .then(function () { if (btn) { btn.disabled = false; btn.classList.remove('hmx-busy'); } });
  }

  // Read the chosen subscription (native selling_plan) from the buy form. Recurpay injects a
  // [name="selling_plan"] input/radio when "Subscribe" is picked; null = one-time.
  function buyPlan(el) {
    var form = el.closest && el.closest('form[data-hm-buy]');
    var scope = form || document;
    var sel = scope.querySelector('[name="selling_plan"]:checked') || scope.querySelector('input[name="selling_plan"]') || scope.querySelector('select[name="selling_plan"]');
    if (sel && sel.value) { return sel.value; }
    var d = scope.querySelector('[data-selling-plan]');
    return (d && d.getAttribute('data-selling-plan')) || null;
  }
  // Managed subscription (no autopay yet): tag the line as a monthly refill. The 5% off is
  // applied as the SUBSCRIBE5 discount at checkout (see placeOrder); recurrence is run by the
  // team via WhatsApp reminders. Only the PDP buy form carries the plan choice.
  function buyPlanProps(el) {
    var form = (el.closest && el.closest('form[data-hm-buy]')) || document.querySelector('form[data-hm-buy]');
    if (!form) return null;
    var sub = form.querySelector('[name="hm-plan"][value="sub"]');
    if (sub && sub.checked) { return { 'Plan': 'Monthly refill (5% off, confirm each order on WhatsApp)' }; }
    return null;
  }
  function pdpCampaignOffer() {
    var form = document.querySelector('form[data-hm-buy]');
    if (!form || form.getAttribute('data-hm-product-handle') !== 'stress-relief') return false;
    if (Date.now() >= Date.parse('2026-10-04T00:00:00+05:30')) return false;
    var source = new URLSearchParams(location.search);
    if (source.get('utm_source') || source.get('utm_campaign') || source.get('gclid') || source.get('fbclid')) return true;
    try {
      var match = document.cookie.match(/(?:^|; )hm_attr=([^;]*)/);
      var first = match ? JSON.parse(decodeURIComponent(match[1])) : {};
      return !!(first.utm_source || first.utm_campaign || first.gclid || first.fbclid);
    } catch (e) { return false; }
  }
  function pdpCodOffer() {
    var form = document.querySelector('form[data-hm-buy]');
    if (!form || form.getAttribute('data-hm-product-handle') !== 'stress-relief') return false;
    if (Date.now() >= Date.parse('2026-10-04T00:00:00+05:30')) return false;
    try {
      var campaign = new URLSearchParams(location.search).get('utm_campaign');
      if (campaign) {
        var matched = campaign === 'hm_cod_stress_sep28';
        sessionStorage.setItem('hm_cod_offer', matched ? '1' : '0');
        return matched;
      }
      return sessionStorage.getItem('hm_cod_offer') === '1';
    } catch (_) { return false; }
  }
  function changeLine(key, qty) {
    var lines = $('[data-hm-lines]'); if (lines) lines.setAttribute('data-hm-pending', '');
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      if (lines) lines.removeAttribute('data-hm-pending'); setCartState(cart); renderSheet(cart);
    }).catch(function () { if (lines) lines.removeAttribute('data-hm-pending'); });
  }
  /* ---------- delivery PIN / address: save, prefill, deliverability, live shipping ---------- */
  function getAddr() { try { return JSON.parse(localStorage.getItem('hm_addr') || 'null'); } catch (e) { return null; } }
  function saveAddr(o) { try { localStorage.setItem('hm_addr', JSON.stringify(o)); } catch (e) {} }
  function setShipStatus(msg, color) { var s = $('[data-hm-addr-status]'); if (s) { s.textContent = msg; s.style.color = color || '#6B776A'; s.style.display = 'block'; } }
  function persistAddr(v) {
    var cur = getAddr() || {}; cur.raw = v; var m = v.match(/\b(\d{6})\b/); if (m) cur.pin = m[1]; saveAddr(cur);
    try { fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Delivery PIN/address': v } }) }); } catch (e) {}
    // (fail-state for the availability check lives in checkDelivery below)
  }
  // India Post public API: validates a real Indian PIN and returns its area/city/state
  function lookupPin(pin) {
    return fetch('https://api.postalpincode.in/pincode/' + pin).then(function (r) { return r.json(); }).then(function (d) {
      var rec = d && d[0];
      if (rec && rec.Status === 'Success' && rec.PostOffice && rec.PostOffice.length) {
        var po = rec.PostOffice[0];
        return { ok: true, area: po.Name, city: po.District, state: po.State };
      }
      return { ok: false };
    }).catch(function () { return { ok: null }; });
  }
  // Shopify's own shipping rates for the current cart at this zip (real, per the store's zones)
  function shopShippingRate(zip, province) {
    var url = '/cart/shipping_rates.json?shipping_address%5Bzip%5D=' + encodeURIComponent(zip) + '&shipping_address%5Bcountry%5D=India' + (province ? '&shipping_address%5Bprovince%5D=' + encodeURIComponent(province) : '');
    function poll(n) {
      return fetch(url, { headers: { 'Accept': 'application/json' } }).then(function (r) {
        if (r.status === 202 && n > 0) { return new Promise(function (res) { setTimeout(res, 700); }).then(function () { return poll(n - 1); }); }
        return r.json().catch(function () { return null; });
      }).catch(function () { return null; });
    }
    return poll(4).then(function (j) {
      if (j && j.shipping_rates && j.shipping_rates.length) {
        var min = j.shipping_rates.reduce(function (a, b) { return parseFloat(b.price) < parseFloat(a.price) ? b : a; });
        return { ok: true, price: Math.round(parseFloat(min.price) * 100) };
      }
      return { ok: false };
    });
  }
  function checkDelivery(value) {
    value = (value || '').trim();
    var m = value.match(/\b(\d{6})\b/);
    if (!m) { setShipStatus('Saved. Add a 6-digit PIN to check delivery + shipping.', '#6B776A'); return Promise.resolve(); }
    var pin = m[1];
    setShipStatus('Checking delivery to ' + pin + '…', '#6B776A');
    return lookupPin(pin).catch(function () { return { ok: null }; }).then(function (res) {
      if (res.ok === false) { setShipStatus('We could not find PIN ' + pin + '. Please recheck it.', '#B5792E'); return; }
      var cur = getAddr() || {}; cur.pin = pin;
      if (res.ok) { cur.city = res.city; cur.state = res.state; cur.area = res.area; }
      saveAddr(cur);
      var place = res.ok ? ('Delivers to ' + res.city + ', ' + res.state) : ('PIN ' + pin);
      return shopShippingRate(pin, res.state).then(function (sr) {
        var shipEl = $('[data-hm-ship]');
        if (sr.ok) {
          var label = sr.price === 0 ? 'Free shipping' : ('Shipping ' + INR(sr.price));
          if (shipEl) { shipEl.textContent = sr.price === 0 ? 'FREE' : INR(sr.price); shipEl.style.color = sr.price === 0 ? '#2F6B2E' : '#15301C'; }
          setShipStatus('✓ ' + place + ' · ' + label, '#2F6B2E');
          fetchCart().then(function (c) { var t = $('[data-hm-total]'); if (t) t.textContent = INR(c.total_price + (sr.price || 0)); });
        } else {
          setShipStatus('✓ ' + place + ' · Delivered across India', '#2F6B2E');
        }
      }).catch(function () { setShipStatus('✓ ' + place + ' · Delivered across India', '#2F6B2E'); });
    });
  }
  function initAddress() {
    var input = $('[data-hm-addr]'); if (!input) return;
    var saved = getAddr();
    if (saved && saved.raw && !input.value) input.value = saved.raw;
    if (saved && saved.raw && /\b\d{6}\b/.test(saved.raw) && document.querySelector('[data-hm-cart-page]')) { setTimeout(function () { checkDelivery(saved.raw); }, 90); }
    var saveBtn = $('[data-hm-addr-save]');
    if (saveBtn) saveBtn.addEventListener('click', function () {
      var v = input.value.trim(); if (!v) { input.focus(); return; }
      saveBtn.classList.add('hmx-busy'); persistAddr(v);
      Promise.resolve(checkDelivery(v)).then(function () { saveBtn.classList.remove('hmx-busy'); }, function () { saveBtn.classList.remove('hmx-busy'); });
    });
    var t;
    input.addEventListener('input', function () { clearTimeout(t); var v = input.value.trim(); if (/\b\d{6}\b/.test(v)) t = setTimeout(function () { persistAddr(v); checkDelivery(v); }, 650); });
    input.addEventListener('change', function () { var v = input.value.trim(); if (v) { persistAddr(v); checkDelivery(v); } });
  }
  // Optional Google Places autocomplete — only if the merchant set a Maps API key
  function initPlaces() {
    var input = $('[data-hm-addr]'); if (!input || !window.hmGmapsKey) return;
    function attach() {
      try {
        var ac = new google.maps.places.Autocomplete(input, { componentRestrictions: { country: 'in' }, fields: ['address_components', 'formatted_address'] });
        ac.addListener('place_changed', function () {
          var p = ac.getPlace(), pin = '', city = '', state = '';
          (p.address_components || []).forEach(function (c) {
            if (c.types.indexOf('postal_code') > -1) pin = c.long_name;
            if (!city && (c.types.indexOf('locality') > -1 || c.types.indexOf('administrative_area_level_2') > -1)) city = c.long_name;
            if (c.types.indexOf('administrative_area_level_1') > -1) state = c.long_name;
          });
          input.value = p.formatted_address || input.value;
          saveAddr({ raw: input.value, pin: pin, city: city, state: state });
          persistAddr(input.value);
          if (pin) checkDelivery(input.value);
        });
      } catch (e) {}
    }
    if (window.google && window.google.maps && window.google.maps.places) { attach(); return; }
    var s = document.createElement('script');
    s.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(window.hmGmapsKey) + '&libraries=places';
    s.async = true; s.onload = attach; document.head.appendChild(s);
  }
  function placeOrder() {
    hmAbConvert('checkout');
    var addr = $('[data-hm-addr]'), note = addr ? addr.value.trim() : '';
    var saved = getAddr() || {};
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).catch(function () { return null; }).then(function (cart) {
      var p = ['checkout[shipping_address][country]=India'];
      if (saved.pin) p.push('checkout[shipping_address][zip]=' + encodeURIComponent(saved.pin));
      if (saved.city) p.push('checkout[shipping_address][city]=' + encodeURIComponent(saved.city));
      if (saved.state) p.push('checkout[shipping_address][province]=' + encodeURIComponent(saved.state));
      if (note && !/^\d{6}$/.test(note)) p.push('checkout[shipping_address][address1]=' + encodeURIComponent(note));
      var hasSub = cart && cart.items && cart.items.some(function (i) { var pl = i.properties && (i.properties.Plan || i.properties.plan); return pl && /subscribe|refill/i.test(pl); });
      if (hasSub) { p.push('discount=SUBSCRIBE5'); }
      var url = '/checkout?' + p.join('&');
      var go = function () { window.location = url; };
      var upd = { attributes: hmAbCartAttributes() };
      try {
        var lastU = JSON.parse(sessionStorage.getItem('hm_utm_last') || 'null');
        if (lastU) Object.keys(lastU).forEach(function (k) { upd.attributes[k] = lastU[k]; });
        var firstU = JSON.parse(localStorage.getItem('hm_utm_first') || 'null');
        if (firstU && firstU.utm_campaign) upd.attributes.first_campaign = firstU.utm_campaign + (firstU.at ? (' (' + firstU.at + ')') : '');
      } catch (e) {}
      if (note) { persistAddr(note); upd.note = 'Delivery: ' + note; }
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(upd) }).then(go, go);
    });
  }

  /* ---------- delegated clicks ---------- */
  function initCart() {
    document.addEventListener('click', function (e) {
      var t = e.target;
      var buyNow = t.closest && t.closest('[data-hm-buy-now]');
      if (buyNow) {
        e.preventDefault();
        var form = document.querySelector('form[data-hm-buy]');
        var chosen = form && form.querySelector('[name="hm-plan"]:checked');
        var step = document.querySelector('[data-hm-step-val]');
        var buyQty = Math.max(1, Math.min(9, parseInt(step && step.textContent, 10) || 1));
        var planId = buyPlan(buyNow);
        if ((chosen && chosen.value === 'sub') || planId) {
          addToCart(buyNow.getAttribute('data-hm-buy-now'), true, buyNow, buyQty, planId, buyPlanProps(buyNow));
          return;
        }
        var attrs = new URLSearchParams();
        attrs.set('attributes[hm_pdp]', buyNow.getAttribute('data-hm-product-handle') || 'product');
        var source = new URLSearchParams(location.search);
        var first = {}, last = {};
        try {
          var match = document.cookie.match(/(?:^|; )hm_attr=([^;]*)/);
          first = match ? JSON.parse(decodeURIComponent(match[1])) || {} : {};
        } catch (er) {}
        try { last = JSON.parse(sessionStorage.getItem('hm_utm_last') || '{}') || {}; } catch (er) {}
        var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'utm_ad', 'utm_adid', 'utm_adsetid'];
        var currentTouch = keys.some(function (key) { return !!source.get(key); });
        var storedTouch = keys.some(function (key) { return !!last[key]; }) ? last : first;
        keys.forEach(function (key) {
          var value = currentTouch ? source.get(key) : storedTouch[key];
          if (value) attrs.set('attributes[' + key + ']', String(value).slice(0, 120));
        });
        if (first.utm_campaign) attrs.set('attributes[first_campaign]', String(first.utm_campaign).slice(0, 120));
        if (pdpCampaignOffer()) attrs.set('discount', pdpCodOffer() ? 'STRESS150' : 'HEALTH10');
        location.assign('/cart/' + encodeURIComponent(buyNow.getAttribute('data-hm-buy-now')) + ':' + buyQty + '?' + attrs.toString());
        return;
      }
      var addMulti = t.closest && t.closest('[data-hm-add-multi]');
      if (addMulti) { e.preventDefault(); addMultiToCart(addMulti.getAttribute('data-hm-add-multi').split(','), true, addMulti); return; }
      var buildAdd = t.closest && t.closest('[data-hm-build-add]');
      if (buildAdd) { e.preventDefault(); var bids = $$('[data-hm-build-item]:checked').map(function (c) { return c.value; }); if (bids.length) addMultiToCart(bids, true, buildAdd); return; }
      var add = t.closest && t.closest('[data-hm-add]');
      if (add) {
        e.preventDefault();
        var stepVal = document.querySelector('[data-hm-step-val]');
        var qty = (add.hasAttribute('data-hm-usestep') && stepVal) ? (parseInt(stepVal.textContent, 10) || 1) : 1;
        addToCart(add.getAttribute('data-hm-add'), add.hasAttribute('data-hm-open-sheet'), add, qty, buyPlan(add), buyPlanProps(add));
        return;
      }
      var sdec = t.closest && t.closest('[data-hm-step-dec]');
      var sinc = t.closest && t.closest('[data-hm-step-inc]');
      if (sdec || sinc) {
        var wrap = (sdec || sinc).closest('[data-hm-step]');
        var v = wrap && wrap.querySelector('[data-hm-step-val]');
        if (v) { var n = parseInt(v.textContent, 10) || 1; v.textContent = sdec ? Math.max(1, n - 1) : Math.min(9, n + 1); }
        return;
      }
      if (t.closest && t.closest('[data-hm-bar-cart]')) { e.preventDefault(); openSheet(); return; }
      if (t.closest && t.closest('[data-hm-sheet-close]')) { closeSheet(); return; }
      if (t.closest && t.closest('[data-hm-overlay]')) { closeSheet(); return; }
      var place = t.closest && t.closest('[data-hm-place]');
      if (place) { place.classList.add('hmx-busy'); placeOrder(); return; }
      var dec = t.closest && t.closest('[data-hm-line-dec]');
      if (dec) { var ds = dec.parentNode.querySelector('span'); var q = Math.max(0, (parseInt(ds.textContent, 10) || 1) - 1); ds.textContent = q; changeLine(dec.getAttribute('data-key'), q); return; }
      var inc = t.closest && t.closest('[data-hm-line-inc]');
      if (inc) { var iv = inc.parentNode.querySelector('span'); var q2 = Math.min(99, (parseInt(iv.textContent, 10) || 1) + 1); iv.textContent = q2; changeLine(inc.getAttribute('data-key'), q2); return; }
      // Shop CTA inside the empty bag: if this page already lists the formulas, close the
      // sheet and scroll to them instead of reloading. The href stays as the no-JS fallback.
      var eshop = t.closest && t.closest('[data-hm-empty-shop]');
      if (eshop && document.getElementById('formulary')) {
        e.preventDefault(); closeSheet();
        var fx = document.getElementById('formulary');
        window.scrollTo({ top: fx.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
        return;
      }
      var bag = t.closest && t.closest('[data-hm-bag]');
      if (bag) {
        // Always open the bag, empty or not. Silently scrolling to the product list left
        // people wondering why the cart would not open.
        e.preventDefault();
        openSheet();
        return;
      }
    });
    document.addEventListener('keyup', function (e) { if (e.key === 'Escape') closeSheet(); });
  }

  /* ---------- PDP sticky buy bar ---------- */
  function initPdpBar() {
    var bar = document.querySelector('[data-hm-bar-pdp]'); if (!bar) return;
    var anchor = document.querySelector('[data-hm-buy-anchor]');
    var form = document.querySelector('form[data-hm-buy]');
    var cents = form ? Number(form.getAttribute('data-hm-price-cents')) : NaN;
    function priced(c) { return '₹' + (Math.round(c) / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    if (form && Number.isFinite(cents)) {
      var refill = form.querySelector('[name="hm-plan"][value="sub"]');
      if (refill) {
        var refillPrice = priced(cents * 0.95);
        refill.setAttribute('data-hm-plan-price', refillPrice);
        var refillRow = refill.closest('.hm-plan').querySelector('.hm-plan__price');
        if (refillRow) refillRow.textContent = refillPrice;
      }
    }
    if (form && Number.isFinite(cents) && pdpCampaignOffer()) {
      var codOffer = pdpCodOffer();
      var campaignPrice = codOffer ? '₹' + Math.round((cents - 15000) / 100).toLocaleString('en-IN') : priced(cents * 0.9);
      var once = form.querySelector('[name="hm-plan"][value="once"]');
      if (once) {
        once.checked = true;
        once.setAttribute('data-hm-plan-price', campaignPrice);
        var rowPrice = once.closest('.hm-plan').querySelector('.hm-plan__price');
        if (rowPrice) {
          var oncePrice = rowPrice.querySelector('[data-hm-once-price]') || rowPrice;
          oncePrice.textContent = campaignPrice;
        }
        var offlinePrice = once.closest('.hm-plan').querySelector('[data-hm-cod-compare]');
        if (offlinePrice) offlinePrice.hidden = !codOffer;
        var summaryPrice = document.querySelector('[data-hm-summary-price]');
        if (summaryPrice) summaryPrice.textContent = campaignPrice;
        var summaryCompare = document.querySelector('[data-hm-cod-compare-mobile]');
        if (summaryCompare) summaryCompare.hidden = !codOffer;
        var summaryOffer = document.querySelector('[data-hm-summary-offer]');
        if (summaryOffer) { summaryOffer.textContent = codOffer ? 'Online offer' : 'HEALTH10 applied'; summaryOffer.hidden = false; }
        $$('[data-hm-routine-price]').forEach(function (item) { item.textContent = campaignPrice; });
        var note = document.querySelector('[data-hm-campaign-code]');
        if (note) { note.textContent = codOffer ? 'STRESS150 applies automatically at checkout.' : 'HEALTH10 applies automatically at checkout.'; note.hidden = false; }
        document.body.classList.add('hm-pdp-campaign');
      }
    }
    function syncPlan() {
      var selected = form && form.querySelector('[name="hm-plan"]:checked');
      var price = bar.querySelector('[data-hm-bar-price]');
      if (selected && price) price.textContent = selected.getAttribute('data-hm-plan-price') || price.textContent;
      var mobilePrice = document.querySelector('[data-hm-mobile-price]');
      if (selected && mobilePrice) mobilePrice.textContent = selected.getAttribute('data-hm-plan-price') || mobilePrice.textContent;
      var mobilePlan = document.querySelector('[data-hm-mobile-plan]');
      if (selected && mobilePlan) mobilePlan.textContent = selected.value === 'sub' ? 'refill' : 'one-time';
      $$('[data-hm-buy-text]').forEach(function (label) {
        label.textContent = selected && selected.value === 'sub' ? 'Review refill' : 'Buy now';
      });
    }
    if (form) form.addEventListener('change', syncPlan);
    syncPlan();
    var ticking = false;
    function upd() {
      var show = anchor ? anchor.getBoundingClientRect().bottom < 8 : (window.scrollY || window.pageYOffset) > 560;
      bar.classList.toggle('is-visible', show);
    }
    window.addEventListener('scroll', function () { if (ticking) return; ticking = true; requestAnimationFrame(function () { upd(); ticking = false; }); }, { passive: true });
    upd();
  }

  /* ---------- smooth-scroll for in-page anchor links (no reload to a section
       you're already on); falls through to normal nav when the target isn't here ---------- */
  function initSmoothScroll() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      var hi = href.indexOf('#');
      if (hi < 0) return;
      var id = href.slice(hi + 1);
      if (!id) return;
      var path = href.slice(0, hi);
      var samePath = (path === '' || path === '/' || path === location.pathname);
      var target = document.getElementById(id);
      if (samePath && target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        try { history.replaceState(null, '', '#' + id); } catch (er) {}
        var menu = $('[data-hm-navmenu]'); if (menu) menu.classList.remove('is-open');
        var tog = $('[data-hm-navtoggle]'); if (tog) tog.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---------- animated accordions (.hm-ac with .hm-ac__head / .hm-ac__panel) ---------- */
  function initAccordions() {
    document.addEventListener('click', function (e) {
      var head = e.target.closest && e.target.closest('.hm-ac__head');
      if (!head) return;
      var ac = head.closest('.hm-ac');
      if (!ac) return;
      var open = ac.classList.toggle('is-open');
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- PDP gallery: thumbs, arrows, keyboard and touch swipe ---------- */
  function initGallery() {
    $$('[data-hm-gallery]').forEach(function (gallery) {
      var main = $('[data-hm-main-img]', gallery);
      var stage = $('.hm-pdp-gallery__stage', gallery);
      var thumbs = $$('[data-hm-thumb]', gallery);
      var count = $('[data-hm-gallery-count]', gallery);
      if (!main || !stage || !thumbs.length) return;
      var index = 0, touchX = null;

      function show(next, focusThumb) {
        index = (next + thumbs.length) % thumbs.length;
        var thumb = thumbs[index];
        main.src = thumb.getAttribute('data-full');
        main.alt = thumb.getAttribute('data-alt') || '';
        thumbs.forEach(function (item, i) {
          var active = i === index;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-current', active ? 'true' : 'false');
        });
        if (count) count.textContent = (index + 1) + ' / ' + thumbs.length;
        thumb.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
        if (focusThumb) thumb.focus();
      }

      gallery.addEventListener('click', function (e) {
        var thumb = e.target.closest && e.target.closest('[data-hm-thumb]');
        if (thumb) { show(thumbs.indexOf(thumb), false); return; }
        if (e.target.closest && e.target.closest('[data-hm-gallery-prev]')) show(index - 1, false);
        if (e.target.closest && e.target.closest('[data-hm-gallery-next]')) show(index + 1, false);
      });
      gallery.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        show(index + (e.key === 'ArrowRight' ? 1 : -1), false);
      });
      stage.addEventListener('touchstart', function (e) { touchX = e.changedTouches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (touchX == null) return;
        var delta = e.changedTouches[0].clientX - touchX;
        touchX = null;
        if (Math.abs(delta) >= 42) show(index + (delta < 0 ? 1 : -1), false);
      }, { passive: true });
    });
  }

  /* ---------- full cart page: steppers + remove -> change then refresh ---------- */
  function initCartPage() {
    var page = $('[data-hm-cart-page]'); if (!page) return;
    page.addEventListener('click', function (e) {
      var dec = e.target.closest && e.target.closest('[data-hm-cart-dec]');
      var inc = e.target.closest && e.target.closest('[data-hm-cart-inc]');
      var rm = e.target.closest && e.target.closest('[data-hm-cart-remove]');
      var el = dec || inc || rm; if (!el) return;
      e.preventDefault();
      var key = el.getAttribute('data-key'), qty;
      if (rm) { qty = 0; }
      else { var span = el.parentNode.querySelector('span'); var cur = parseInt(span ? span.textContent : '1', 10) || 1; qty = dec ? Math.max(0, cur - 1) : cur + 1; if (span) span.textContent = qty; }
      var lines = $('[data-hm-cart-lines]'); if (lines) lines.setAttribute('data-hm-pending', '');
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function () { window.location.reload(); })
        .catch(function () { if (lines) lines.removeAttribute('data-hm-pending'); });
    });
  }

  /* ---------- collection: goal filter chips ---------- */
  function initCollection() {
    var sec = document.querySelector('#grid[data-hm-filter]'); if (!sec) return;
    var count = $('[data-hm-filter-count]'), empty = $('[data-hm-filter-empty]');
    function apply(key) {
      sec.setAttribute('data-hm-filter', key);
      var shown = 0;
      $$('.hm-colgrid > [data-goal]').forEach(function (c) { var on = key === 'all' || c.getAttribute('data-goal') === key; c.style.display = on ? '' : 'none'; if (on) shown++; });
      $$('[data-hm-filter-set]').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-hm-filter-set') === key); });
      if (count) count.textContent = shown + (shown === 1 ? ' formula' : ' formulas');
      if (empty) empty.style.display = shown === 0 ? 'block' : 'none';
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-hm-filter-set]'); if (!b) return;
      apply(b.getAttribute('data-hm-filter-set'));
    });
  }

  /* ---------- predictive search (live results w/ images, semantic via tag+body) ---------- */
  /* ---------- search typo tolerance: correct to the known catalog vocabulary ---------- */
  var HM_VOCAB = ['resveratrol', 'ashwagandha', 'omega', 'magnesium', 'multivitamin', 'vitamin', 'melatonin', 'collagen', 'calm', 'sleep', 'stress', 'energy', 'heart', 'brain', 'skin', 'glow', 'immunity', 'focus', 'active', 'radiant'];
  var HM_FIX = { reservatrol: 'resveratrol', resveritrol: 'resveratrol', resveratol: 'resveratrol', reverastrol: 'resveratrol', ashwaganda: 'ashwagandha', ashwgandha: 'ashwagandha', aswagandha: 'ashwagandha', ashwaganda: 'ashwagandha', omega3: 'omega', magnesim: 'magnesium', magnesum: 'magnesium', multivitamins: 'multivitamin', mutlivitamin: 'multivitamin', imunity: 'immunity', sleeep: 'sleep', strss: 'stress' };
  function hmLev(a, b) {
    var m = a.length, n = b.length, d = [], i, j;
    for (i = 0; i <= m; i++) { d[i] = [i]; }
    for (j = 0; j <= n; j++) { d[0][j] = j; }
    for (i = 1; i <= m; i++) { for (j = 1; j <= n; j++) { d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + (a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1)); } }
    return d[m][n];
  }
  function hmCorrect(q) {
    var raw = (q || '').toLowerCase().trim(); if (!raw) return null;
    var changed = false;
    var out = raw.split(/\s+/).map(function (t) {
      if (t.length < 4) return t;
      if (HM_FIX[t]) { changed = true; return HM_FIX[t]; }
      var best = null, bestD = 3;
      HM_VOCAB.forEach(function (w) { if (Math.abs(t.length - w.length) <= 2) { var dist = hmLev(t, w); if (dist < bestD) { bestD = dist; best = w; } } });
      if (best && bestD <= 2 && best !== t) { changed = true; return best; }
      return t;
    });
    var corrected = out.join(' ');
    return (changed && corrected !== raw) ? corrected : null;
  }

  function initSearch() {
    var ov = $('[data-hm-search]'); if (!ov) return;
    var input = $('[data-hm-search-input]'), results = $('[data-hm-search-results]'),
        empty = $('[data-hm-search-empty]'), allLink = $('[data-hm-search-all]'), spin = $('[data-hm-search-spin]');
    var timer, seq = 0;
    var searchInr = function (v) { return '₹' + Math.round(parseFloat(v || '0')).toLocaleString('en-IN'); };

    function open() { ov.hidden = false; document.body.style.overflow = 'hidden'; setTimeout(function () { input.focus(); }, 30); }
    function close() { ov.hidden = true; document.body.style.overflow = ''; }

    function row(p) {
      var a = document.createElement('a'); a.className = 'hm-search__row'; a.href = p.url; a.setAttribute('role', 'option');
      var src = (p.featured_image && p.featured_image.url) || p.image, img;
      if (src) { img = document.createElement('img'); img.className = 'hm-search__thumb'; img.src = src; img.alt = ''; img.width = 50; img.height = 50; img.loading = 'lazy'; }
      else { img = document.createElement('span'); img.className = 'hm-search__thumb'; }
      a.appendChild(img);
      var txt = document.createElement('div'); txt.className = 'hm-search__rtext';
      var parts = (p.title || '').split(' · ');
      var nm = document.createElement('div'); nm.className = 'hm-search__rname'; nm.textContent = parts[0]; txt.appendChild(nm);
      var sub = parts[1] || (p.tags && p.tags[0]) || '';
      if (sub) { var s = document.createElement('div'); s.className = 'hm-search__rtag'; s.textContent = sub; txt.appendChild(s); }
      a.appendChild(txt);
      var pr = document.createElement('span'); pr.className = 'hm-search__rprice'; pr.textContent = searchInr(p.price); a.appendChild(pr);
      return a;
    }

    function render(prods, q) {
      while (results.firstChild) results.removeChild(results.firstChild);
      if (prods === null) { empty.style.display = 'block'; results.style.display = 'none'; allLink.hidden = true; return; }
      empty.style.display = 'none'; results.style.display = 'block';
      if (!prods.length) {
        var none = document.createElement('div'); none.className = 'hm-search__none';
        var b = document.createElement('b'); b.textContent = 'No matches for “' + q + '”'; none.appendChild(b);
        var pp = document.createElement('div'); pp.textContent = 'Try a feeling — calm, energy, skin — or browse all formulas.'; none.appendChild(pp);
        results.appendChild(none);
        allLink.hidden = false; allLink.textContent = 'Browse all formulas →'; allLink.href = (window.routes && window.routes.search_url) || '/search';
        return;
      }
      prods.forEach(function (p) { results.appendChild(row(p)); });
      allLink.hidden = false; allLink.textContent = 'See all results for “' + q + '” →';
      allLink.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
    }

    function doSearch(q, retried) {
      q = (q || '').trim();
      if (!q) { render(null); return; }
      spin.hidden = false; var my = ++seq;
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,tag,body&resources[options][unavailable_products]=last';
      fetch(url, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (d) {
        if (my !== seq) return; // stale response
        var prods = (d && d.resources && d.resources.results && d.resources.results.products) || [];
        if (!prods.length && !retried) { var fix = hmCorrect(q); if (fix) { doSearch(fix, true); return; } } // typo correction retry, keep spinner up
        spin.hidden = true;
        render(prods, q);
      }).catch(function () { if (my === seq) spin.hidden = true; });
    }

    $$('[data-hm-search-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-hm-search-close]').forEach(function (b) { b.addEventListener('click', close); });
    $$('[data-hm-search-chip]').forEach(function (c) { c.addEventListener('click', function () { input.value = c.getAttribute('data-hm-search-chip'); input.focus(); doSearch(input.value); }); });
    input.addEventListener('input', function () { clearTimeout(timer); var v = input.value; timer = setTimeout(function () { doSearch(v); }, 180); });
    input.addEventListener('keydown', function (e) {
      var rows = $$('.hm-search__row', results);
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Enter') { var act = results.querySelector('.hm-search__row.is-active'); if (act) { window.location = act.href; return; } var q = input.value.trim(); if (q) window.location = '/search?q=' + encodeURIComponent(q) + '&type=product'; return; }
      if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && rows.length) {
        e.preventDefault();
        var i = rows.findIndex(function (r) { return r.classList.contains('is-active'); });
        rows.forEach(function (r) { r.classList.remove('is-active'); });
        i = e.key === 'ArrowDown' ? (i + 1) % rows.length : (i <= 0 ? rows.length - 1 : i - 1);
        rows[i].classList.add('is-active'); rows[i].scrollIntoView({ block: 'nearest' });
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !ov.hidden) close(); });
  }

  /* ---------- /search results page (driven by the predictive endpoint) ---------- */
  function initSearchPage() {
    var host = $('[data-hm-searchpage]'); if (!host) return;
    var grid = $('[data-hm-sp-grid]', host), top = $('[data-hm-sp-top]', host),
        countEl = $('[data-hm-sp-count]', host), recovery = $('[data-hm-sp-recovery]', host),
        loading = $('[data-hm-sp-loading]', host), sortSel = $('[data-hm-sp-sort]', host);
    var q = (host.getAttribute('data-q') || '').trim();
    if (!q) { try { q = (new URLSearchParams(location.search).get('q') || '').trim(); } catch (e) {} }
    if (!q) { if (recovery) recovery.style.display = 'block'; return; }

    function spInr(v) { return '₹' + Math.round(parseFloat(v || '0')).toLocaleString('en-IN'); }
    function card(p) {
      var parts = (p.title || '').split(' · '), nm = parts[0], tg = parts[1] || (p.tags && p.tags[0]);
      var c = document.createElement('div'); c.setAttribute('data-hm-result', ''); c.dataset.price = parseFloat(p.price || '0'); c.dataset.name = nm;
      c.style.cssText = 'display:flex;flex-direction:column;border:1px solid #E7E5DB;border-radius:20px;overflow:hidden;background:#fff';
      var a = document.createElement('a'); a.href = p.url; a.style.cssText = 'position:relative;aspect-ratio:1/1;background:linear-gradient(165deg,#EEF1E8,#E0E5D7);display:block';
      var src = (p.featured_image && p.featured_image.url) || p.image;
      if (src) { var im = document.createElement('img'); im.src = src; im.alt = ''; im.loading = 'lazy'; im.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover'; a.appendChild(im); }
      if (tg) { var tt = document.createElement('span'); tt.textContent = tg; tt.style.cssText = 'position:absolute;top:12px;right:12px;font-size:10.5px;letter-spacing:0.06em;color:#2F6B2E;font-weight:600;background:#fff;border:1px solid #DDE3D3;padding:4px 9px;border-radius:100px'; a.appendChild(tt); }
      c.appendChild(a);
      var body = document.createElement('div'); body.style.cssText = 'padding:16px 16px 18px;display:flex;flex-direction:column;flex:1';
      var row = document.createElement('div'); row.style.cssText = 'display:flex;justify-content:space-between;align-items:baseline;gap:10px';
      var h = document.createElement('h3'); h.textContent = nm; h.style.cssText = 'margin:0;font-weight:400;font-size:17px;letter-spacing:-0.02em;color:#15301C';
      var pr = document.createElement('span'); pr.textContent = spInr(p.price); pr.style.cssText = 'font-weight:500;font-size:15px;white-space:nowrap;color:#15301C';
      row.appendChild(h); row.appendChild(pr); body.appendChild(row);
      var act = document.createElement('div'); act.style.cssText = 'margin-top:auto;padding-top:14px';
      var vid = p.variants && p.variants[0] && p.variants[0].id;
      if (p.available && vid) { var btn = document.createElement('button'); btn.type = 'button'; btn.setAttribute('data-hm-add', vid); btn.setAttribute('data-hm-open-sheet', ''); var hcta = p.handle || ((p.url || '').split('/products/')[1] || '').split('?')[0]; btn.textContent = HM_CTA[hcta] || 'Add to bag'; btn.style.cssText = 'width:100%;border:1px solid #2F6B2E;background:#fff;color:#2F6B2E;font-family:inherit;font-size:14.5px;font-weight:600;padding:12px;border-radius:100px;cursor:pointer'; act.appendChild(btn); }
      else { var vl = document.createElement('a'); vl.href = p.url; vl.textContent = 'View formula'; vl.style.cssText = 'display:block;text-align:center;width:100%;box-sizing:border-box;border:1px solid #2F6B2E;color:#2F6B2E;text-decoration:none;font-size:14.5px;font-weight:600;padding:12px;border-radius:100px'; act.appendChild(vl); }
      body.appendChild(act); c.appendChild(body); return c;
    }

    if (loading) loading.style.display = 'block';
    function spFetch(term, retried) {
      var url = '/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=12&resources[options][fields]=title,product_type,variants.title,tag,body&resources[options][unavailable_products]=last';
      fetch(url, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (d) {
        var prods = (d && d.resources && d.resources.results && d.resources.results.products) || [];
        if (!prods.length && !retried) { var fix = hmCorrect(term); if (fix) { spFetch(fix, true); return; } } // typo correction retry
        if (loading) loading.style.display = 'none';
        if (!prods.length) { if (recovery) recovery.style.display = 'block'; return; }
        prods.forEach(function (p) { grid.appendChild(card(p)); });
        if (countEl) countEl.textContent = prods.length + (prods.length === 1 ? ' result' : ' results') + (retried ? ' for “' + term + '”' : '');
        if (top) top.style.display = 'flex';
      }).catch(function () { if (loading) loading.style.display = 'none'; if (recovery) recovery.style.display = 'block'; });
    }
    spFetch(q, false);

    if (sortSel) sortSel.addEventListener('change', function () {
      var items = $$('[data-hm-result]', grid), v = sortSel.value;
      items.sort(function (a, b) {
        if (v === 'price-asc') return parseFloat(a.dataset.price) - parseFloat(b.dataset.price);
        if (v === 'price-desc') return parseFloat(b.dataset.price) - parseFloat(a.dataset.price);
        if (v === 'name') return (a.dataset.name || '').localeCompare(b.dataset.name || '');
        return 0;
      });
      items.forEach(function (n) { grid.appendChild(n); });
    });
  }

  // Build-your-stack: live running total + count as products are toggled.
  function initBuilder() {
    var host = $('[data-hm-builder]'); if (!host) return;
    var items = $$('[data-hm-build-item]', host), totalEl = $('[data-hm-build-total]', host), countEl = $('[data-hm-build-count]', host), btn = $('[data-hm-build-add]', host);
    function inr(p) { return '₹' + Math.round(p / 100).toLocaleString('en-IN'); }
    function upd() {
      var sum = 0, n = 0;
      items.forEach(function (c) {
        if (c.checked) { sum += parseInt(c.getAttribute('data-price'), 10) || 0; n++; }
        var card = c.closest('[data-hm-build-card]'); if (card) card.classList.toggle('is-on', c.checked);
      });
      if (totalEl) totalEl.textContent = inr(sum);
      if (countEl) countEl.textContent = n;
      if (btn) { btn.disabled = n < 1; btn.textContent = n < 1 ? 'Pick at least one' : (n === 1 ? 'Add to bag' : 'Add my stack of ' + n); }
    }
    items.forEach(function (c) { c.addEventListener('change', upd); });
    upd();
  }

  // Mouse loupe: hover the product image -> a circular magnifier follows the cursor.
  // Desktop/mouse only. Maps the object-fit:cover crop so the zoomed lens lines up with
  // exactly what's shown in the box.
  function initLoupe() {
    if (!(window.matchMedia && window.matchMedia('(pointer: fine)').matches)) return;
    var img = $('[data-hm-main-img]'); if (!img) return;
    var wrap = img.parentNode; if (!wrap) return;
    var lens = document.createElement('div'); lens.className = 'hm-loupe'; lens.setAttribute('aria-hidden', 'true');
    wrap.appendChild(lens);
    var SIZE = 190, ZOOM = 2.3;
    function hiSrc() { var s = img.currentSrc || img.src || ''; return s.match(/width=\d+/) ? s.replace(/width=\d+/, 'width=1600') : (s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=1600'); }
    function metrics() {
      var r = img.getBoundingClientRect();
      var nW = img.naturalWidth || 1, nH = img.naturalHeight || 1;
      var sc = Math.min(r.width / nW, r.height / nH); // object-fit: contain
      var dw = nW * sc, dh = nH * sc;
      return { r: r, dw: dw, dh: dh, ox: (r.width - dw) / 2, oy: (r.height - dh) / 2 };
    }
    wrap.addEventListener('mouseenter', function () { lens.style.backgroundImage = 'url("' + hiSrc() + '")'; });
    wrap.addEventListener('mouseleave', function () { lens.style.display = 'none'; });
    wrap.addEventListener('mousemove', function (e) {
      var m = metrics(), r = m.r;
      var cx = e.clientX - r.left, cy = e.clientY - r.top;
      var ix = cx - m.ox, iy = cy - m.oy;
      if (ix < 0 || iy < 0 || ix > m.dw || iy > m.dh) { lens.style.display = 'none'; return; }
      lens.style.display = 'block';
      lens.style.width = SIZE + 'px'; lens.style.height = SIZE + 'px';
      lens.style.left = (cx - SIZE / 2) + 'px';
      lens.style.top = (cy - SIZE / 2) + 'px';
      lens.style.backgroundSize = (m.dw * ZOOM) + 'px ' + (m.dh * ZOOM) + 'px';
      lens.style.backgroundPosition = (-(ix * ZOOM - SIZE / 2)) + 'px ' + (-(iy * ZOOM - SIZE / 2)) + 'px';
    });
  }

  function init() {
    initReveal(); initChat(); initLang(); initTabs(); initNav(); initBar(); initPdpBar(); initCart();
    initSmoothScroll(); initAccordions(); initGallery(); initAddress(); initPlaces(); initCartPage(); initCollection(); initSearch(); initSearchPage(); initBuilder(); initLoupe(); initAB(); initAnchorRouter();
    fetchCart().then(setCartState).catch(function () {});
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
